import { FormattedDate } from "react-intl"
import CustomFormattedTime from "../time/CustomFormattedTime"

const FormattedDateTimeNumeric = ({ date, dateTimeSeparator = " ", dateProps = {}, timeProps = {} }) => {
  return (
    <>
      <FormattedDate day="2-digit" month="2-digit" value={date} year="numeric" {...dateProps} />
      {dateTimeSeparator}
      <CustomFormattedTime value={date} {...timeProps} />
    </>
  )
}

export default FormattedDateTimeNumeric
